export default {
      id: "ic-home-discussion-usage",
      viewBox: "0 0 53 57",
      url: "../dist/images/" + "sprite.svg#ic-home-discussion-usage",
      toString: function () {
        return this.url;
      }
    }